var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeSmallIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.998 10.226a6.402 6.402 0 0 0 12.003 0H1.998Z",
  fill: "#FFCF00"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 1.6a6.402 6.402 0 0 0-6.002 4.174h12.004A6.402 6.402 0 0 0 8 1.6Z",
  fill: "#000"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.998 5.774A6.386 6.386 0 0 0 1.6 8c0 .783.14 1.533.398 2.226H14A6.385 6.385 0 0 0 14.4 8c0-.783-.141-1.533-.399-2.226H1.998Z",
  fill: "#D72A1D"
})));
export { SvgDeSmallIcon as ReactComponent };
export default __webpack_public_path__ + "2e5a318c9ec54e3a16bcfae01bf15237.svg";